import React from "react";
import { Box, Grid, Skeleton } from "@mui/material";

export default function StudentFormSkeleton() {
  return (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={2}>
        {/* Left side - form fields */}
        <Grid item xs={12} md={8}>
          <Grid container spacing={2}>
            {/* Profile image */}
            <Grid item xs={12} md={4} sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
              <Skeleton variant="rectangular" width={180} height={180} sx={{ borderRadius: "8px" }} />
            </Grid>

            {/* Name, Grade, Sec */}
            <Grid item xs={12} md={4}>
              <Skeleton variant="text" width={80} height={28} sx={{ mb: 1 }} />
              <Skeleton variant="rectangular" height={48} sx={{ borderRadius: "8px", mb: 2 }} />
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Skeleton variant="text" width={50} height={28} />
                  <Skeleton variant="rectangular" height={48} sx={{ borderRadius: "8px" }} />
                </Grid>
                <Grid item xs={6}>
                  <Skeleton variant="text" width={40} height={28} />
                  <Skeleton variant="rectangular" height={48} sx={{ borderRadius: "8px" }} />
                </Grid>
              </Grid>
            </Grid>

            {/* Student ID, Class Teacher */}
            <Grid item xs={12} md={4}>
              <Skeleton variant="text" width={90} height={28} sx={{ mb: 1 }} />
              <Skeleton variant="rectangular" height={48} sx={{ borderRadius: "8px", mb: 2 }} />
              <Skeleton variant="text" width={110} height={28} sx={{ mb: 1 }} />
              <Skeleton variant="rectangular" height={48} sx={{ borderRadius: "8px" }} />
            </Grid>

            {/* Parent row */}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {[1, 2, 3].map((i) => (
                  <Grid item xs={12} md={4} key={i}>
                    <Skeleton variant="text" width={90} height={28} sx={{ mb: 1 }} />
                    <Skeleton variant="rectangular" height={48} sx={{ borderRadius: "8px" }} />
                  </Grid>
                ))}
              </Grid>
            </Grid>

            {/* Route / Vehicle / Stops row */}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {[1, 2, 3, 4].map((i) => (
                  <Grid item xs={12} md={3} key={i}>
                    <Skeleton variant="text" width={80} height={28} sx={{ mb: 1 }} />
                    <Skeleton variant="rectangular" height={48} sx={{ borderRadius: "8px" }} />
                  </Grid>
                ))}
              </Grid>
            </Grid>

            {/* Driver / Attendant row */}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {[1, 2].map((i) => (
                  <Grid item xs={12} md={6} key={i}>
                    <Skeleton variant="text" width={70} height={28} sx={{ mb: 1 }} />
                    <Skeleton variant="rectangular" height={48} sx={{ borderRadius: "8px" }} />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Right side - map skeleton */}
        <Grid item xs={12} md={4}>
          <Skeleton variant="rectangular" sx={{ borderRadius: "12px", height: "100%", minHeight: 350 }} />
        </Grid>
      </Grid>

      {/* Action buttons */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
        <Skeleton variant="rectangular" width={100} height={44} sx={{ borderRadius: "8px" }} />
        <Skeleton variant="rectangular" width={120} height={44} sx={{ borderRadius: "8px" }} />
        <Skeleton variant="rectangular" width={120} height={55} sx={{ borderRadius: "8px" }} />
      </Box>
    </Box>
  );
}